import { render, staticRenderFns } from "./online-status-indicator.vue?vue&type=template&id=b0f25d42&scoped=true&"
import script from "./online-status-indicator.vue?vue&type=script&lang=js&"
export * from "./online-status-indicator.vue?vue&type=script&lang=js&"
import style0 from "./online-status-indicator.vue?vue&type=style&index=0&id=b0f25d42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f25d42",
  null
  
)

export default component.exports